import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {SignupService} from "../../../services/signup.service";
import {timer} from "rxjs";
import {numbersOnlyPattern, urlPattern} from "../../../../common/utilities/CustomValidator";
import {isFormSubmitted} from "../../../../common/utilities/FormsHelper";
import {APIClientService} from "../../../../common/services/apiclient.service";
import {Field} from "../../../../common/enums/Field";
import {ValidationErrorType} from "../../../../common/enums/ValidationErrorType";
import {MerchantApi} from "../../../../common/apis/merchant-api";
import { AppNavigator, NavigatorTarget } from "../../../../services/app-navigator";

@Component({
  selector: 'app-merchant-contact-info',
  templateUrl: './merchant-contact-info.component.html',
  styleUrls: ['./merchant-contact-info.component.css']
})
export class MerchantContactInfoComponent implements OnInit {
  @ViewChild('mobileNumberVerificationModal') modal: ElementRef;
  public mobileNumberForm: FormGroup
  public socialMediaLinksForm: FormGroup
  public mobileNumberVerificationForm: FormGroup

  public resendTimerSeconds = 30
  // public resendTimer = "00:00"
  public disableResendVerificationButton = true

  public mobileNumberVerified = false

  public mobileNumberErrorMessage: string | null = null
  public loadingAddMobileButton = false
  public disableAddMobileForm = false
  public verifyMobileNumberSuccessMessage: string | null = null
  public loadingVerifyMobileButton = false
  public disableVerifyMobileButton = true
  public addMobileNumberErrorMessage: string | null = null
  public verifyMobileNumberErrorMessage: string | null = null

  constructor(
    private formBuilder: FormBuilder,
    private apiClient: APIClientService,
    public signupService: SignupService,
    private router: Router,
    private renderer: Renderer2,
    private merchantApi: MerchantApi,
    private appNavigator: AppNavigator,
  ) {
  }

  ngOnInit() {
    if (localStorage.getItem("user")) {
      let merchantId = JSON.parse(localStorage.getItem("user")!).merchantId
      if (!merchantId) {
        this.router.navigate(["/merchants/signup/login"])
      }
    }
    else {
      this.router.navigate(["/merchants/signup/login"])
    }

    this.signupService.currentStepBs.next(this.signupService.Step.MERCHANT_CONTACT_INFO);
    this.signupService.disableBackButton = false
    this.signupService.disableNextButton = false

    this.mobileNumberForm = this.formBuilder.group({
      countryCode: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(256)]],
      mobileNumber: ['', [Validators.required, Validators.pattern(numbersOnlyPattern()), Validators.minLength(5), Validators.maxLength(256)]],
      hasWhatsapp: [true, []],
      hasTelegram: [true, []]
    });
    this.signupService.mobileNumberForm = this.mobileNumberForm

    this.mobileNumberForm.patchValue({"countryCode": "20"}) // Hard coded for now as we only accept Egyptian businesses

    this.socialMediaLinksForm = this.formBuilder.group({
      website: ['', [Validators.minLength(10), Validators.maxLength(256), Validators.pattern(urlPattern())]],
      instagram: ['', [Validators.minLength(10), Validators.maxLength(256), Validators.pattern(urlPattern())]],
      facebook: ['', [Validators.minLength(10), Validators.maxLength(256), Validators.pattern(urlPattern())]],
      tiktok: ['', [Validators.minLength(10), Validators.maxLength(256), Validators.pattern(urlPattern())]],
      youtube: ['', [Validators.minLength(10), Validators.maxLength(256), Validators.pattern(urlPattern())]],
      x: ['', [Validators.minLength(10), Validators.maxLength(256), Validators.pattern(urlPattern())]]
    });
    this.signupService.socialMediaLinksForm = this.socialMediaLinksForm


    this.mobileNumberVerificationForm = this.formBuilder.group({
      digit1: ['', [Validators.required, Validators.min(0), Validators.max(9)]],
      digit2: ['', [Validators.required, Validators.min(0), Validators.max(9)]],
      digit3: ['', [Validators.required, Validators.min(0), Validators.max(9)]],
      digit4: ['', [Validators.required, Validators.min(0), Validators.max(9)]],
      digit5: ['', [Validators.required, Validators.min(0), Validators.max(9)]],
      digit6: ['', [Validators.required, Validators.min(0), Validators.max(9)]]
    });

    // TODO Temporarily disable this code and replace with the next one to get the mobile number
    // if (localStorage.getItem("verifiedCountryCode") && localStorage.getItem("verifiedMobileNumber")) {
    //   this.mobileNumberVerified = true
    //   this.signupService.mobileNumberVerified = true
    //
    //
    //   this.mobileNumberForm.patchValue({"mobileNumber": localStorage.getItem("verifiedMobileNumber")})
    // }

    if (localStorage.getItem("countryCode") && localStorage.getItem("mobileNumber")) {
      this.mobileNumberForm.patchValue({"countryCode": localStorage.getItem("countryCode")})
      this.mobileNumberForm.patchValue({"mobileNumber": localStorage.getItem("mobileNumber")})
    }
  }

  submitMobileNumberForm() {
    // TODO: Not sure what to do here :)
  }

  verifyMobileNumber() {

  }

  openVerifyMobileModal() {
    if (isFormSubmitted(this.mobileNumberForm)) {
      let countryCode = this.mobileNumberForm.get("countryCode")?.value
      let mobileNumber: string = this.mobileNumberForm.get("mobileNumber")?.value + ""
      let hasWhatsapp: boolean = this.mobileNumberForm.get("hasWhatsapp")?.value
      if (!hasWhatsapp)
        hasWhatsapp = false
      let hasTelegram: boolean = this.mobileNumberForm.get("hasTelegram")?.value
      if (!hasTelegram)
        hasTelegram = false
      this.loadingAddMobileButton = true
      this.disableAddMobileForm = true
      this.merchantApi.addMerchantPhone(countryCode, mobileNumber, hasWhatsapp, hasTelegram).subscribe({
        next: () => {
          this.loadingAddMobileButton = false

          localStorage.setItem("countryCode", countryCode)
          localStorage.setItem("mobileNumber", mobileNumber)

          // TODO: AAAA Disable checking that the mobile number is verified for now.
          // this.openModal()
          // this.startResendEnablementTimer()
        },
        error: error => {
          localStorage.removeItem("countryCode")
          localStorage.removeItem("mobileNumber")

          this.loadingAddMobileButton = true
          this.resetMobileNumberErrorMessages()

          if (Array.isArray(error)) {
            // Handle each error separately
            console.log("error is an array")
            error.map(singleError => {
              console.log(singleError.errorType)
              console.log(singleError.field)

              if (singleError.field == Field.PHONE_NUMBER) {
                if (singleError.errorType == ValidationErrorType.INVALID_FORMAT) {
                  this.mobileNumberErrorMessage = $localize`Invalid mobile number format.`
                } else if (singleError.errorType == ValidationErrorType.REQUIRED) {
                  this.mobileNumberErrorMessage = $localize`Mobile number is required.`
                }
              }
            });
          } else {
            // TODO: Check if type of error is string before printing
            if (error === ValidationErrorType.UNAUTHORIZED) {
              this.signupService.currentStepBs.next(this.signupService.Step.MERCHANT_LOGIN);
              this.appNavigator.navigateTo({ target: NavigatorTarget.merchantLogin })
              // this.router.navigate(["/merchants/signup/login"])
            } else
              this.mobileNumberErrorMessage = $localize`Something went wrong. Please try again later or contact support.`
          }
        },
      })
    }
  }

  private resetMobileNumberErrorMessages() {
    this.mobileNumberErrorMessage = null
    this.addMobileNumberErrorMessage = null
    this.verifyMobileNumberErrorMessage = null
  }

  onPINCodeKeyup(event: KeyboardEvent, nextInput?: HTMLInputElement, previousInput?: HTMLInputElement): void {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace') {
      if (previousInput) {
        if (input.value.length === 0) {
          previousInput.focus();
        }
      }
    } else {

      if (input.value.length === 1 && nextInput) {
        nextInput.focus();
      }
    }
  }

  // onPINCodeKeydown(event: KeyboardEvent, previousInput?: HTMLInputElement): void {
  //   console.log(event)
  //   console.log(previousInput)
  //   if (event.key === 'Backspace' && previousInput) {
  //     console.log("inside")
  //     const input = event.target as HTMLInputElement;
  //     console.log("Value length is " + input.value.length)
  //     if (input.value.length === 0) {
  //       console.log("Value length is zeroo")
  //       previousInput.focus();
  //     }
  //   }
  // }

  resendMobileNumberVerificationCode() {
    isFormSubmitted(this.mobileNumberForm)
    {
      this.disableResendVerificationButton = true
      this.startResendEnablementTimer()


      // let countryCode = this.mobileNumberForm.get("countryCode")?.value
      // let mobileNumber = this.mobileNumberForm.get("mobileNumber")?.value

      let countryCode = localStorage.getItem("countryCode")
      let mobileNumber = localStorage.getItem("mobileNumber")

      if (countryCode && mobileNumber) {
        this.loadingAddMobileButton = true
        this.disableAddMobileForm = true
        this.merchantApi.resendMerchantPhoneSMS(countryCode, mobileNumber).subscribe({
          next: () => {
            this.loadingAddMobileButton = false

            this.verifyMobileNumberSuccessMessage = $localize`PIN code resend request sent successfully.`
          },
          error: error => {
            this.resetMobileNumberErrorMessages()

            if (Array.isArray(error)) {
              // Handle each error separately
              console.log("error is an array")
              error.map(singleError => {
                console.log(singleError.errorType)
                console.log(singleError.field)

              });
            } else {
              // TODO: Check if type of error is string before printing
              if (error === ValidationErrorType.UNAUTHORIZED) {
                localStorage.removeItem("countryCode")
                localStorage.removeItem("mobileNumber")

                this.signupService.currentStepBs.next(this.signupService.Step.MERCHANT_LOGIN);

                this.appNavigator.navigateTo({ target: NavigatorTarget.merchantLogin })
                // this.router.navigate(["/merchants/signup/login"])
              } else
                this.mobileNumberErrorMessage = $localize`Something went wrong. Please try again later or contact support.`
            }
          },
        })
      }
    }
  }

  submitMobileNumberVerificationForm() {
    if (isFormSubmitted(this.mobileNumberVerificationForm) && this.digit1 && this.digit2 && this.digit3 && this.digit4 && this.digit5 && this.digit6) {
      // let token = this.digit1.concat(this.digit1 + this.digit2+ this.digit3 + this.digit4 + this.digit5 + this.digit6
      let token = this.digit1.value + "" + this.digit2.value + "" + this.digit3.value + "" + this.digit4.value + "" + this.digit5.value + "" + this.digit6.value
      this.loadingVerifyMobileButton = true
      this.apiClient.verifyMerchantPhone(token).subscribe({
        next: () => {

          if (localStorage.getItem("countryCode") && localStorage.getItem("mobileNumber")) {
            localStorage.setItem("verifiedCountryCode", localStorage.getItem("countryCode")!)
            localStorage.setItem("verifiedMobileNumber", localStorage.getItem("mobileNumber")!)

            localStorage.removeItem("countryCode")
            localStorage.removeItem("mobileNumber")
          }


          this.signupService.mobileNumberVerified = true
          this.mobileNumberVerified = true
          this.loadingVerifyMobileButton = false
          this.closeModal();
        },
        error: error => {
          this.loadingVerifyMobileButton = false
          this.resetMobileNumberErrorMessages()

          if (Array.isArray(error)) {
            // Handle each error separately
            console.log("error is an array")
            error.map(singleError => {
              console.log(singleError.errorType)
              console.log(singleError.field)
            });
          } else {
            // TODO: Check if type of error is string before printing
            if (error === ValidationErrorType.UNAUTHORIZED) {
              this.signupService.currentStepBs.next(this.signupService.Step.MERCHANT_LOGIN);
              this.appNavigator.navigateTo({ target: NavigatorTarget.merchantLogin })
              // this.router.navigate(["/merchants/signup/login"])
            } else if (error === ValidationErrorType.TOKEN_MISMATCH)
              this.verifyMobileNumberErrorMessage = $localize`Incorrect PIN code`
            else
              this.verifyMobileNumberErrorMessage = $localize`Something went wrong. Please try again later or contact support.`
          }
        },
      })
    }
  }

  private startResendEnablementTimer() {
    this.resendTimerSeconds = 30

    const countdownTimer = timer(1000, 1000).subscribe(elapsed => {
      this.resendTimerSeconds--;
      if (this.resendTimerSeconds === 0) {
        countdownTimer.unsubscribe();
        this.disableResendVerificationButton = false
      }
    });
  }

  submitSocialMediaLinksForm() {
    // TODO: Not sure what to do here :)
  }


  // Handle Modal view state
  openModal() {
    this.renderer.addClass(this.modal.nativeElement, 'show');
    this.renderer.setStyle(this.modal.nativeElement, 'display', 'block');
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
  }

  closeModal() {
    this.renderer.removeClass(this.modal.nativeElement, 'show');
    this.renderer.setStyle(this.modal.nativeElement, 'display', 'none');
    this.renderer.removeStyle(document.body, 'overflow');
  }

  onContainerClicked(event: MouseEvent): void {
    if ((event.target as Element).classList.contains('modal')) {
      this.closeModal();
    }
  }

  get countryCode() {
    return this.mobileNumberForm.get('countryCode');
  }

  get mobileNumber() {
    return this.mobileNumberForm.get('mobileNumber');
  }

  get hasWhatsapp() {
    return this.mobileNumberForm.get('hasWhatsapp');
  }

  get hasTelegram() {
    return this.mobileNumberForm.get('hasTelegram');
  }

  get digit1() {
    return this.mobileNumberVerificationForm.get('digit1');
  }

  get digit2() {
    return this.mobileNumberVerificationForm.get('digit2');
  }

  get digit3() {
    return this.mobileNumberVerificationForm.get('digit3');
  }

  get digit4() {
    return this.mobileNumberVerificationForm.get('digit4');
  }

  get digit5() {
    return this.mobileNumberVerificationForm.get('digit5');
  }

  get digit6() {
    return this.mobileNumberVerificationForm.get('digit6');
  }

  get website() {
    return this.socialMediaLinksForm.get('website');
  }

  get instagram() {
    return this.socialMediaLinksForm.get('instagram');
  }

  get facebook() {
    return this.socialMediaLinksForm.get('facebook');
  }

  get tiktok() {
    return this.socialMediaLinksForm.get('tiktok');
  }

  get youtube() {
    return this.socialMediaLinksForm.get('youtube');
  }

  get x() {
    return this.socialMediaLinksForm.get('x');
  }
}
